<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      base: '$e$Pp7h80F5k4D3s'
    }
  }
}
</script>

<style>
  a  {
    text-decoration: none;
    color: #000;
  }
  body  {
    margin: 0;
    box-sizing: border-box;
  }
  * {
    box-sizing: border-box;
  }
</style>
